<template>
  <div v-for="(product, index) in products" :data-key="index">
    <productlist
      categoryid="extraproducts"
      :mode="mode"
      :count="count"
      :showaddtocart="showaddtocart"
      :showprocessorder="showprocessorder"
      :step="step"
      :postMountedProducts="[product]"
      :columnFormat="columnformat"
      :showBeforeText="showBeforeText"
      :showAfterText="showAfterText"
    />
  </div>
</template>

<script>
import productlist from "@/components/productlist/ProductList.vue";

export default {
  name: "ProductExtraProducts",
  components: {
    productlist,
  },
  data() {
    return {
      products: {
        type: Array,
      },
    };
  },
  props: {
    mode: {
      type: String,
      default: "products-grid",
    },
    count: {
      type: Number,
      default: 3,
    },
    columnformat: {
      type: String,
      default: "4/8",
    },
    postMountedProducts: {
      type: Array,
    },
    showaddtocart: {
      type: Boolean,
      default: true,
    },
    showprocessorder: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Number,
      default: 0,
    },
    showBeforeText: {
      type: Boolean,
      default: false,
    },
    showAfterText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  mounted() {
    this.products = this.postMountedProducts;
  },
  watch: {
    postMountedProducts: {
      handler(newValue) {
        this.products = newValue;
      },
    },
  },
};
</script>
